import axios from "axios";

export const phoneVerification = async (
  phoneNumber: string,
  phoneCall: boolean = false,
): Promise<boolean> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;

    const response = await axios.post(
      `${apiUrl}/VerifyNewPhone`,
      {
        phoneNumber,
        phoneCall,
      },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.status >= 200 && response.status < 300;
  } catch (error: any) {
    console.error(
      "Échec de la vérification du téléphone :",
      error?.response?.data || error.message,
    );
    return false;
  }
};

export const resendPhoneVerification = async (
  phoneNumber: string,
): Promise<boolean> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    const response = await axios.post(
      `${apiUrl}/resendPhoneVerification`,
      {
        phoneNumber,
      },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response.status === 200) {
      return true;
    }
  } catch (error: any) {
    // console.error("Phone verification failed:", error?.response?.data || error.message);
    return false;
  }

  return false;
};

export const confirmPhoneVerification = async (
  code: string,
): Promise<boolean> => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    const response = await axios.post(
      `${apiUrl}/confirmPhone`,
      {
        code,
      },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response.status === 200) {
      return true;
    }
  } catch (error: any) {
    // console.error("Phone verification failed:", error?.response?.data || error.message);
    return false;
  }

  return false;
};

